<template>
  <section
    class="human-support-guarantee py-5 bg-white
      border-top border-bottom"
  >
    <div class="container">
      <div
        class="card bg-primary-dark-base text-white p-4
          p-md-5 rounded-xl shadow-lg position-relative
          overflow-hidden"
      >
        <div class="row align-items-center position-relative z-index-2">
          <div class="col-lg-8 text-left mb-4 mb-lg-0">
            <span
              class="badge badge-success-base px-3 py-2
                text-uppercase font-weight-bold mb-3"
            >
              🤝 Acompañamiento 100% Incluido
            </span>
            <h2 class="h1 font-weight-bold mb-3">
              No estás solo: Configuramos tu cuenta y plantillas
              desde el primer día
            </h2>
            <p class="lead opacity-90 mb-4">
              Sabemos que estás ocupado. Al adquirir tu membresía,
              nuestro equipo de atención al cliente te ayuda a personalizar
              tus plantillas, subir tus formatos de récipes, logos
              y parámetros para que empieces a trabajar sin esfuerzo.
            </p>

            <div class="row">
              <div class="col-sm-6 mb-3">
                <div class="d-flex align-items-center">
                  <span
                    class="badge badge-light text-primary-base
                      rounded-circle p-2 font-weight-bold mr-2"
                  >
                    1
                  </span>
                  <span>
                    <strong>Sesión de bienvenida:</strong>
                    Encuentro virtual guiado.
                  </span>
                </div>
              </div>
              <div class="col-sm-6 mb-3">
                <div class="d-flex align-items-center">
                  <span
                    class="badge badge-light text-primary-base
                      rounded-circle p-2 font-weight-bold mr-2"
                  >
                    2
                  </span>
                  <span>
                    <strong>Carga de formatos:</strong>
                    Tu logo y firma listos.
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-4 text-center">
            <div class="p-4 bg-white text-dark rounded-xl shadow-md">
              <img
                src="/img/support.png"
                alt="Soporte AMII"
                class="img-fluid rounded-lg mb-3"
              >
              <div class="h5 font-weight-bold text-dark-blue mb-2">
                Soporte Dedicado
              </div>
              <p class="small text-muted mb-3">
                Atención personalizada de Lunes a Viernes
                de 8:00 AM a 5:00 PM
              </p>
              <button
                class="btn btn-success-base btn-block font-weight-bold
                  py-2 btn-pulse-success"
                @click="$emit('start-register')"
              >
                Comenzar con Asistencia →
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HumanSupportGuarantee',
};
</script>

<style scoped>
.text-dark-blue {
  color: #002196;
}
.bg-primary-dark-base {
  background-color: #002196;
}
</style>
